module.exports = __webpack_public_path__ + "media/images/icons/icon_heart_hand-1af0e8ddc62a8ba4d5961db951d245cd.svg";